<template>
  <div class="mydepartment">
    <div class="con">
      <div class="left-table">
        <div class="Files-top">
          <div class="ic-left">
            <span>部门管理</span>
          </div>
          <div class="btns">
            <el-button @click="add_ed" type="primary" class="last-el-button">新增</el-button>
          </div>
        </div>
        <div class="mytable" style="margin-top:20px">
          <el-table ref="multipleTable" :data="departmentData" :height="heights" style="width: 100%" stripe border>
            <template slot="empty">
              <span class="noData">
                <img src="@/assets/noData.png" alt="暂无数据">
                <span class="text">暂无数据</span>
              </span>
            </template>
            <el-table-column width="90" label="序号" align="center">
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column label="名称" prop="name"></el-table-column>
            <el-table-column label="操作" align="center">
              <template #default="{row}">
                <div class="buttoned_box">
                  <div @click="edit_fn(row)" class="mr-20">
                    <el-tooltip class="item" effect="dark" content="编辑" placement="top">
                      <elIconBtn btnType='edit'></elIconBtn>
                    </el-tooltip>
                  </div>
                  <div @click="del_fun(row)">
                    <el-tooltip class="item" effect="dark" content="删除" placement="top">
                      <elIconBtn btnType='del'></elIconBtn>
                    </el-tooltip>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="right-tree">
        <div class="bumen-tree">
          <div class="right-top">部门</div>
          <el-input v-model="filterText" placeholder="输入关键字进行过滤" clearable style="margin-right:10px"></el-input>
          <el-scrollbar style="height:calc(100% - 85px);width: 100%;">
            <el-tree :data="departmentData" show-checkbox node-key="id" :props="defaultProps" default-expand-all
              @node-click="bumenClick" @check="bumenCurrentChecked" ref="bumenTree">
              <span class="custom-tree-node" slot-scope="{node}">
                <img src="../../../../public/static/image/elTree/group.png" v-if="node.data.users">
                <img src="../../../../public/static/image/elTree/yuangong.png" v-else>
                <span style="padding-left: 5px;">{{node.data.name}}</span>
              </span>
            </el-tree>
          </el-scrollbar>
        </div>
        <div class="dra-btns">
          <div class="left-add" @click="saveDevice">绑定<img src="@/assets/left.png" alt=""></div>
          <div class="del" @click="device_Del">移除<img src="@/assets/right.png" alt=""></div>
        </div>
        <div class="yuangong-tree">
          <div class="right-top">员工</div>
          <el-input v-model="filterText" placeholder="输入关键字进行过滤" clearable style="margin-right:10px"></el-input>
          <el-scrollbar style="height:calc(100% - 85px);width: 100%;">
            <el-tree :data="staffData" show-checkbox node-key="id" :props="staffDefaultProps" @check="currentChecked"
              :filter-node-method="filterNode" ref="tree">
              <span class="custom-tree-node" slot-scope="{node}">
                <img src="../../../../public/static/image/elTree/1.9.png" v-if="node.data.entityName == 'UsePowerUnit'">
                <img src="../../../../public/static/image/elTree/yuangong.png" v-else>
                <span style="padding-left: 5px;">{{node.data.userName}}</span>
              </span>
            </el-tree>
          </el-scrollbar>
        </div>
      </div>

      <el-dialog :title="textMapMenu[dialogStatus]" :close-on-click-modal='false' v-dialogDrag
        :visible.sync="dialogVisible" width="20%" center>

        <div style="display: flex;" class="dialog">
          <el-form :model="tempMenu" ref="temp" label-width="39px" style="padding-top: 10px; display: flex;
                        flex-wrap: wrap;" :inline="true">
            <el-form-item label="名称：" prop="name">
              <el-input v-model="addName"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="dialogStatus==='edit'?determine('tempMenu'):add_fun('tempMenu')">确 定
            </el-button>
          </span>
        </template>
      </el-dialog>
    </div>
  </div>
</template>
<script>
  import elIconBtn from '@/components/module/iconBtns.vue'
  import {departmentFindAllUser,departmentSaveUserId,departmentDeleteAllUserd,departmentSave,deleteDepartment,updateById,getUserTree} from "../../../api/order";
  export default {
    components: {
      elIconBtn
    },
    data () {
      return {
        textMapMenu: {
          add: "新增",
          edit: "修改"
        },
        tempMenu: {},
        loading: false,
        heights: document.getElementById('app').clientHeight-200,//屏幕高度 - 导航栏高度
        dialogTableVisible: false,
        temp: {},
        dialogStatus: '',

        tableData: [],
        dialogVisible: false,

        conditions: {},
        mainId: '',
        rules: {
          name: [
            {required: true,message: '请输入部门名称',trigger: 'blur'}
          ],

        },
        topLevel: 0,
        addName: "",
        deviceName: "",
        departmentId: "",
        searchName: "",
        multipleSelection: [],
        departmentData: [],
        checkedNodes: [],
        staffData: [
          {
            "userId": "c17101ba832749529471fe818496f741",
            "userName": "wd"
          },
          {
            "userId": "1051231df55d44b38195318a54ce12ec",
            "userName": "1"
          },
          {
            "userId": "fdca82ef7caa4a12a48189fedb53bec4",
            "userName": "ZH"
          },
          {
            "userId": "2113912b5c164f67856366574c7739b7",
            "userName": "ABB"
          },
          {
            "userId": "690e842f0a00419593d58753c4b3ff14",
            "userName": "2"
          },
          {
            "userId": "2754798e7f6a46de82a4c2e21e747e7a",
            "userName": "QQ"
          }
        ],
        //以下是设备列表树形
        filterText: '',
        deviceData: [],//设备树形结构
        //部门树形类型
        defaultProps: {
          children: 'users',
          label: 'name'
        },
        //员工树形类型
        staffDefaultProps: {
          children: 'next',
          label: 'userName'
        },
        bumenName: "",
        bumenCheckedNodes: [],

      };
    },
    created () {
      this.getUserTreeFun()


    },
    mounted () {

      this.departmentFindAllUserFun();//获取列表数据 

    },
    methods: {
      //部门数据
      departmentFindAllUserFun () {

        var list=[
          {
            "departmentId": 239384664842241,
            "departmentName": "测试部",
            "users": [
              {
                "userId": "d5b5b3349eae4ab8afcaf648b32fd6e9",
                "userName": "test2"
              },
              {
                "userId": "eab7a420f95643a0a81e567f1b78ec71",
                "userName": "子公司2用户"
              },
              {
                "userId": "73301657fa7c4054bc4a5bfaab4be1a7",
                "userName": "111"
              },
              {
                "userId": "b296f4a2b50f45958778caa53d26b586",
                "userName": "a"
              }
            ]
          },
          {
            "departmentId": 239384690300929,
            "departmentName": "设计部",
            "users": [
              {
                "userId": "c17101ba832749529471fe818496f741",
                "userName": "wd"
              },
              {
                "userId": "1051231df55d44b38195318a54ce12ec",
                "userName": "1"
              },
              {
                "userId": "fdca82ef7caa4a12a48189fedb53bec4",
                "userName": "ZH"
              },
              {
                "userId": "2113912b5c164f67856366574c7739b7",
                "userName": "ABB"
              },
              {
                "userId": "690e842f0a00419593d58753c4b3ff14",
                "userName": "2"
              },
              {
                "userId": "2754798e7f6a46de82a4c2e21e747e7a",
                "userName": "QQ"
              }
            ]
          },
          {
            "departmentId": 240440573517825,
            "departmentName": "财务部",
            "users": [
              {
                "userId": "89b73705dd194fd7a48a5940e501810c",
                "userName": "t1"
              },
              {
                "userId": "9b82f35d45d24460849d64b30f0e9613",
                "userName": "3"
              }
            ]
          },
          {
            "departmentId": 302346270072833,
            "departmentName": "技术部",
            "users": []
          }
        ]

        this.departmentData=list

        this.departmentData=JSON.parse(JSON.stringify(this.departmentData).replace(/departmentId/g,'id').replace(/userId/g,"id").replace(/departmentName/g,'name').replace(/userName/g,"name"))
        var a=this.staffData
        var recursiveFunction=function() {
          const getStr=function(list) {
            list.forEach(function(row) {
              if(row.hasOwnProperty('next')) {
                getStr(row.next)
              } else {
                row.disabled=false
                res.data.forEach(item => {
                  item.users.forEach(t => {
                    if(row.id==t.userId) {
                      row.disabled=true
                    }
                  })

                })

              }
            })
          }
          getStr(a)
        }
        recursiveFunction()
        // this.departmentData = []
        // this.chosenArr = []
        this.loading=true
        departmentFindAllUser().then(res => {
          this.loading=false
          if(res.code==200) {

          }
        })

      },
      // 员工数据
      getUserTreeFun () {
        getUserTree().then(res => {
          if(res.success) {

            var recursiveFunction=function() {
              const getStr=function(list) {
                list.forEach(function(row) {
                  if(row.hasOwnProperty('next')) {
                    getStr(row.next)
                  } else {
                    row['disabled']=false
                  }
                })
              }
              getStr([res.data])
            }
            recursiveFunction()
            this.staffData=[res.data]
            this.staffData=JSON.parse(JSON.stringify(this.staffData).replace(/username/g,'name'))
            //  console.log("员工数据",res);
            this.departmentFindAllUserFun()

          }

        })
      },
      //添加部门
      add_fun () {

        if(this.addName=='') {
          this.$message({type: 'warning',message: '请输入部门名称'});
          return
        }
        departmentSave({"departmentName": this.addName}).then(res => {
          if(res.code==200) {
            this.$message({showClose: true,message: '添加成功',type: 'success'});
            this.departmentFindAllUserFun()
            this.dialogVisible=false
          } else {
            this.$message({showClose: true,message: '添加失败',type: 'warning'});
            this.dialogVisible=false
          }
        })
      },
      // 添加菜单弹窗
      add_ed () {
        this.dialogStatus='add';
        this.dialogVisible=true;
        this.addName=""
        // console.log(v);
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });
      },
      // 删除部门
      del_fun (row) {
        console.log("row",row);
        this.$confirm(`是否删除 ${row.name}`,'提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          deleteDepartment({"id": row.id}).then(res => {
            //    console.log("res",res);
            if(res.code==200) {
              this.$message({showClose: true,message: '删除成功',type: 'success'});
              this.departmentFindAllUserFun()
            } else {
              this.$message({showClose: true,message: `${res.message}`,type: 'warning'});
            }
          })
        }).catch(() => {
          // ...
        });

      },
      //修改部门名称
      edit_fn (row) {
        this.dialogStatus='edit';
        this.dialogVisible=true
        this.departmentId=row.id
        this.addName=row.name
      },
      //确定修改
      determine () {
        if(this.addName=='') {
          this.$message({type: 'warning',message: '部门名称不能为空'});
          return
        }
        updateById({"departmentName": this.addName,"id": this.departmentId}).then(res => {
          if(res.code==200) {
            this.departmentFindAllUserFun()
            this.$message({message: '修改成功',type: 'success'});
            this.temp={}
          } else {
            this.$message({message: '修改失败',type: 'warning'});

          }
          this.dialogVisible=false
        })

      },
      //部门树形结构点击
      bumenClick (v) {

        if(v.hasOwnProperty('users')) {
          this.mainId=v.id
          this.bumenName=v.name
        }
      },
      //员工树形结构选中节点
      currentChecked (nodeObj,SelectedObj) {
        this.checkedNodes=SelectedObj.checkedNodes
        this.checkedNodes=this.checkedNodes.filter(item => item.type=='PcmUser')
      },
      //部门树形结构选中节点
      bumenCurrentChecked (nodeObj,SelectedObj) {
        var arr=SelectedObj.checkedNodes
        if(SelectedObj.halfCheckedNodes.length==1) {
          this.mainId=SelectedObj.halfCheckedNodes[0].id
          this.bumenName=SelectedObj.halfCheckedNodes[0].name
        } else {
          var b=arr.filter(item => item.hasOwnProperty('users'))
          if(b.length==0) {
            this.mainId=''
            this.bumenName=''
          } else {
            this.mainId=b[0].id
            this.bumenName=b[0].name
          }

        }
        this.bumenCheckedNodes=arr.filter(item => !item.hasOwnProperty('users'))
      },

      // 绑定员工
      saveDevice () {
        if(this.mainId=="") {
          this.$message({type: 'warning',message: '请选择部门'});
          return
        }
        if(this.checkedNodes.length==0) {
          this.$message({type: 'warning',message: '请选择员工'});
          return
        }

        var ids=""
        this.checkedNodes.forEach(item => ids+=','+item.id)
        ids=ids.slice(1)
        var d={
          "departmentId": this.mainId,
          "users": ids
        };
        departmentSaveUserId(d).then(res => {
          if(res.code==200) {
            this.$message({message: '添加成功',type: 'success'});
            this.$refs.tree.setCheckedKeys([]);
            this.departmentFindAllUserFun()
          } else {
            this.$message({message: '添加失败',type: 'warning'});
          }
        })



      },
      //移除分项的关联设备
      device_Del () {
        if(this.mainId=="") {
          this.$message({type: 'warning',message: '请选择部门'});
          return
        }
        // console.log("this.multipleSelection",this.multipleSelection);
        if(this.bumenCheckedNodes.length==0) {
          this.$message({type: 'warning',message: '请勾选需要移除的员工!'});
          return
        }
        var str=""
        this.bumenCheckedNodes.forEach(item => str+=','+item.id)
        // console.log(ids.split(1));
        str=str.slice(1)
        let d={
          "departmentId": this.mainId,
          "userIds": str
        }
        departmentDeleteAllUserd(d).then(res => {
          if(res.code==200) {
            this.$message({message: '移除成功',type: 'success'});
            this.$refs.bumenTree.setCheckedKeys([]);
            this.mainId=""
            this.bumenName=""
            this.departmentFindAllUserFun()
          } else {
            this.$message({type: 'success',message: `移除失败,${res.message}`});
          }
        })
        // subentryDeleteDevice(d).then(res => {
        //    if(res.code ==200){
        //      this.$message({type: 'success',message: '移除成功!'});
        //        this.$refs.tree.setCheckedKeys([]);
        //      this.departmentFindAllUserFun()
        //    }else {
        //     this.$message({type: 'success',message: `移除失败,${res.message}`});
        //    }
        // })

      },
      //输入关键字进行过滤
      filterNode (value,data) {
        if(!value) return true;
        return data.Content.Name.indexOf(value)!==-1;
      },
















    }
  };
</script>

<style lang="scss" scoped>
  .mydepartment {
    .con {
      width: 100%;
      height: 100%;
      //  background-color: #fff;
      box-sizing: border-box;
      display: flex;
    }

    .left-table {
      width: calc(100% - 738px);
      height: 100%;
      background-color: #fff;
      margin-right: 8px;
      padding: 12px 20px 20px 20px;
      box-sizing: border-box;

      .buttoned_box {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .dra-btns {
      width: 88px;
      margin: 0px 12px;
      margin-top: 240px;

      .left-add,
      .del {
        width: 88px;
        height: 32px;
        background-color: #368ED9;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 2px;
      }

      .del {
        background-color: #ED6547;
        margin-top: 40px;
      }
    }

    .right-tree {
      width: 728px;
      height: 100%;
      background-color: #fff;
      display: flex;
      padding: 12px;
      box-sizing: border-box;

      .bumen-tree {
        width: 300px;
        height: 100%;
        border-right: 1px solid #e6e6e6;
        box-sizing: border-box;
        padding-right: 12px;

      }

      .yuangong-tree {
        width: 300px;
        height: 100%;
        border-left: 1px solid #e6e6e6;
        box-sizing: border-box;
        padding-left: 12px;
      }

      .right-top {
        font-size: 16px;
        color: #1a1a1a;
        margin-bottom: 20px;
      }
    }
  }

  /deep/.el-dialog__header {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #E6E6E6;

    span {
      color: #67A3ED;
      font-size: 14px;
      font-weight: bold;
    }

    .el-icon-close {
      font-size: 20px !important;
    }

  }

  /deep/.el-dialog__footer {
    margin-top: 20px;
    text-align: right !important;
    border-top: 1px solid #E6E6E6;

    button {
      padding: 8px 17px;
    }
  }

  .demo-temp {
    display: flex;
    flex-wrap: wrap;
  }

  /deep/.el-form-item {
    display: flex;
    margin-left: 20px;
  }

  /deep/.el-form-item__label {
    white-space: nowrap;
    width: 86px;
  }

  /deep/.el-dialog__body {
    padding: 20px 0px 0px 20px !important;
  }

  .dialog {
    /deep/.el-input__inner {
      width: 217px;
    }
  }
</style>